import React from "react";

import emptyTeam from "assets/images/manageTeam/emptyTeam.png";

import "./emptyTeam.scss";
import Button from "components/Button/index";

function EmptyTeam({ handleModal }) {
  return (
    <div className="EmptyTeam">
      <div className="EmptyTeamContainer">
        <div className="EmptyTeamTop">
          <img src={emptyTeam} alt="empty" />
        </div>
        <div className="EmptyTeamWrapper">
          <h1>Create Team</h1>
          <p>Use the add button to Create a new Team</p>
        </div>
        <Button title="+ Add Team" type="violet" onClick={handleModal} />
      </div>
    </div>
  );
}

export default EmptyTeam;
